/** @deprecated use StoreStatusEnum instead */
export type StoreStatus = 'ACTIVE' | 'INACTIVE' | 'WITHOUT_ACCESS';

export enum StoreStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  WITHOUT_ACCESS = 'WITHOUT_ACCESS',
}

export interface AdminStoreFormItem {
  location?: string;
  status?: StoreStatusEnum;
  isPJ?: boolean;
  documentType?: string;
  commercialName?: string;
  companyName?: string;
  stateInscription?: string;
  cpfcnpj?: string | null;
  email?: string;
  phone?: string;
  countryCode?: string;
  slug?: string;
  observation?: string;
  verified?: boolean;
  inPendingVerification?: boolean;
  createdAt?: string | Date | null;
}
